import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterService } from 'src/app/masters/master.service';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { SharedService } from 'src/app/utils/shared.service';
import swal from 'sweetalert2';
import * as CommonConstants from '../../utils/common.constants';

@Component({
  selector: 'app-logistic-file',
  templateUrl: './logistic-file.component.html',
  styleUrls: ['./logistic-file.component.scss']
})
export class LogisticFileComponent implements OnInit {

  logisticsPatientWiseForm: FormGroup;
  logisticPackageForm: FormGroup;
  logisticsPatientAccompanionPackageForm: FormGroup;
  logisticFollowUpTransportForm: FormGroup;
  logisticFollowUpAccomadationForm: FormGroup;
  logisticFollowupOtherForm: FormGroup;
  patientLogisticForm: FormGroup;
  patientAccomadationForm: FormGroup;
  medfiId;
  MASTER_PARAM_KEY = [CommonConstants.LOGISTIC_CATEGORY, CommonConstants.LOGISTIC_MEDICAL_ACCOMADATION, CommonConstants.LOGISTIC_CONCERNED,
  CommonConstants.LOGISTIC_RELATIONSHIP, CommonConstants.LOGISTIC_FLIGHT_TYPE, CommonConstants.LOGISTIC_ACCOMADATION_TYPE,
  CommonConstants.LOGISTIC_ROOM_TYPE, CommonConstants.LOGISTIC_FOLLOWUP_REASON, CommonConstants.LOGISTIC_FOLLOWUP_SPECIAL_NEED,
  CommonConstants.LOGISTIC_PAYMENT, CommonConstants.LOGISTIC_FOLLOWUP_STATUS, CommonConstants.LOGISTIC_FOLLOWUP_ACC_ACCESSIBILITY,
  CommonConstants.LOGISTIC_FOLLOWUP_NUMBER, CommonConstants.GENDER]
  PARAM_KEY = [CommonConstants.TRANSFER_REASON, CommonConstants.STATUS];
  MD_FILE_PARAM_KEY = [CommonConstants.MED_LOGISTIC_PAT_WISE, CommonConstants.MED_LOGISTIC_PAT_LOGISTIC_PACKAGE,
  CommonConstants.MED_LOGISTIC_PAT_ACCOMDATION_PACKAGE, CommonConstants.MED_LOGISTIC_PAT_LOGISTIC,
  CommonConstants.MED_LOGISTIC_FOLLOW_TRANSPORT, CommonConstants.MED_LOGISTIC_FOLLOW_ACCOMDATION,
  CommonConstants.MED_LOGISTIC_FOLLOW_OTHER, CommonConstants.MED_LOGISTIC_PAT_ACCOMDATION];
  patientWiseList = [];
  medicalPackageList = [];
  logisticPackageList = [];
  accompanionMedPackageList = [];
  accompanionLogPackageList
  patientLogisticList = [];
  folowupTransportList = [];
  followupAccomadationList = [];
  followupOtherList = [];
  patientAccomadationList = [];

  msCategory = [];
  msMedicalAccomadation = [];
  msConcerned = [];
  msRelationship = [];
  msFlightType = [];
  msAccomadationType = [];
  msRoomType = [];
  msFollowupReason = [];
  msFollowupSpecialNeed = [];
  msPayment = [];
  msFollowupStatus = [];
  msFollowupAccessibility = [];
  msFollowupNumber = [];
  msGender = [];

  patientPkgType = CommonConstants.MEDICAL_PATIENT_PACKAGE_TYPE;
  medicalPkgType = CommonConstants.LOGISTIC_PATIENT_PKG_TYPE;

  accompanionPkgTypeMed = CommonConstants.PAT_ACCOMPANION_PKG_TYPE_MED;
  accompanionPkgTypeLog = CommonConstants.PAT_ACCOMPANION_PKG_TYPE_LOG;

  constructor(private modal: NgbModal, private formBuilder: FormBuilder, private sharedService: SharedService,
    private medicalFileService: MedicalFileService, private masterService: MasterService) { }

  ngOnInit() {
    this.getFormroup();
    this.sharedService.medicalFileId$.subscribe(res => {
      this.medfiId = res;
      this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
        if (response && response['result']) {
          let masterValues = response['result'];
          this.msCategory = masterValues.filter(master => master.paramKey === CommonConstants.LOGISTIC_CATEGORY);
          this.msMedicalAccomadation = masterValues.filter(master => master.paramKey === CommonConstants.LOGISTIC_MEDICAL_ACCOMADATION);
          this.msConcerned = masterValues.filter(master => master.paramKey === CommonConstants.LOGISTIC_CONCERNED);
          this.msRelationship = masterValues.filter(master => master.paramKey === CommonConstants.LOGISTIC_RELATIONSHIP);
          this.msFlightType = masterValues.filter(master => master.paramKey === CommonConstants.LOGISTIC_FLIGHT_TYPE);
          this.msAccomadationType = masterValues.filter(master => master.paramKey === CommonConstants.LOGISTIC_ACCOMADATION_TYPE);
          this.msRoomType = masterValues.filter(master => master.paramKey === CommonConstants.LOGISTIC_ROOM_TYPE);
          this.msFollowupReason = masterValues.filter(master => master.paramKey === CommonConstants.LOGISTIC_FOLLOWUP_REASON);
          this.msFollowupSpecialNeed = masterValues.filter(master => master.paramKey === CommonConstants.LOGISTIC_FOLLOWUP_SPECIAL_NEED);
          this.msPayment = masterValues.filter(master => master.paramKey === CommonConstants.LOGISTIC_PAYMENT);
          this.msFollowupStatus = masterValues.filter(master => master.paramKey === CommonConstants.LOGISTIC_FOLLOWUP_STATUS);
          this.msFollowupAccessibility = masterValues.filter(master => master.paramKey === CommonConstants.LOGISTIC_FOLLOWUP_ACC_ACCESSIBILITY);
          this.msFollowupNumber = masterValues.filter(master => master.paramKey === CommonConstants.LOGISTIC_FOLLOWUP_NUMBER);
          this.msGender = masterValues.filter(master => master.paramKey === CommonConstants.GENDER);
          this.getPatientWiseByKey();
        }
      })
    });
  }

  /**
  * To get form controls
  */
  get patWiseF() { return this.logisticsPatientWiseForm.controls; }
  get medPackF() { return this.logisticPackageForm.controls; }
  get medAccF() { return this.logisticsPatientAccompanionPackageForm.controls; }
  get patLogF() { return this.patientLogisticForm.controls; }
  get followTranF() { return this.logisticFollowUpTransportForm.controls; }
  get followAccF() { return this.logisticFollowUpAccomadationForm.controls; }
  get followOthrF() { return this.logisticFollowupOtherForm.controls; }
  get patAccF() { return this.patientAccomadationForm.controls; }

  private getFormroup() {
    this.logisticsPatientWiseForm = this.formBuilder.group({
      'logpwId': new FormControl(),
      'logpwPayingParty': new FormControl(),
      'logpwCashier': new FormControl(),
      'logpwPtpolicy': new FormControl(),
      'logpwPtpolicyRef': new FormControl(),
      'logpwPolicydate': new FormControl(),
      'medfiId': new FormControl(),
      'staRecCode': new FormControl(),
      'logpwPolicyExpirydate': new FormControl()
    })

    this.logisticPackageForm = this.formBuilder.group({
      'logppId': new FormControl(),
      'logppDurationLimitto': new FormControl(),
      'logppFullPackage': new FormControl(),
      'logppMaxamountLimitto': new FormControl(),
      'logppNotapplicable': new FormControl(),
      'logppPatientPackageType': new FormControl(),
      'logppPercentage': new FormControl(),
      'lpcatId': new FormControl(),
      'medfiId': new FormControl(),
      'mpcatId': new FormControl(),
      'staRecCode': new FormControl()
    })

    this.logisticsPatientAccompanionPackageForm = this.formBuilder.group({
      'logpaId': new FormControl(),
      'logpaFamilialacc': new FormControl(),
      'logpaMedicalacc': new FormControl(),
      'logpaOtheracc': new FormControl(),
      'logpaPatientAccompanionPackageType': new FormControl(),
      'medfiId': new FormControl(),
      'staRecCode': new FormControl()
    })

    this.patientLogisticForm = this.formBuilder.group({
      'logplId': new FormControl(),
      'fltypId': new FormControl(),
      'logplClasses': new FormControl(),
      'logplComment': new FormControl(),
      'logplCompany': new FormControl(),
      'logplConcernedtype': new FormControl(),
      'logplTransfer': new FormControl(),
      'medfiId': new FormControl(),
      'relatId': new FormControl(),
      'staRecCode': new FormControl()
    })

    this.logisticFollowUpTransportForm = this.formBuilder.group({
      'id': new FormControl(),
      'accompanion': new FormControl(),
      'addfrom': new FormControl(),
      'addto': new FormControl(),
      'age': new FormControl(),
      'appointmenttime': new FormControl(),
      'aptdate': new FormControl(),
      'carrier': new FormControl(),
      'category': new FormControl(),
      'gender': new FormControl(),
      'medfiId': new FormControl(),
      'patientname': new FormControl(),
      'payment': new FormControl(),
      'planneddate': new FormControl(),
      'proposecost': new FormControl(),
      'reason': new FormControl(),
      'specialneed': new FormControl(),
      'staRecCode': new FormControl(),
      'status': new FormControl()
    })

    this.logisticFollowUpAccomadationForm = this.formBuilder.group({
      'id': new FormControl(),
      'accessibility': new FormControl(),
      'affectation': new FormControl(),
      'age': new FormControl(),
      'arrival': new FormControl(),
      'departure': new FormControl(),
      'gender': new FormControl(),
      'medfiId': new FormControl(),
      'patientname': new FormControl(),
      'nberrooms': new FormControl(),
      'payment': new FormControl(),
      'personRoom': new FormControl(),
      'planneddate': new FormControl(),
      'proposecost': new FormControl(),
      'reason': new FormControl(),
      'report': new FormControl(),
      'roomtype': new FormControl(),
      'staRecCode': new FormControl(),
      'star': new FormControl()
    })

    this.logisticFollowupOtherForm = this.formBuilder.group({
      'id': new FormControl(),
      'comment': new FormControl(),
      'cost': new FormControl(),
      'date': new FormControl(),
      'description': new FormControl(),
      'medfiId': new FormControl(),
      'number': new FormControl(),
      'patientname': new FormControl(),
      'place': new FormControl(),
      'staRecCode': new FormControl(),
      'time': new FormControl(),
      'type': new FormControl(),
    })

    this.patientAccomadationForm = this.formBuilder.group({
      'logpaId': new FormControl(),
      'actypId': new FormControl(),
      'logpaAllinclude': new FormControl(),
      'logpaBreakfast': new FormControl(),
      'logpaCommunication': new FormControl(),
      'logpaConcernedtype': new FormControl(),
      'logpaMeals': new FormControl(),
      'logpaStar': new FormControl(),
      'relatId': new FormControl(),
      'rotypId': new FormControl(),
      'medfiId': new FormControl(),
      'staRecCode': new FormControl(),
    })

  }

  patientWiseAddModal(addPatientWise) {
    this.modal.open(addPatientWise, { container: '.page-content' });
  }
  savePatientWise() {
    this.logisticsPatientWiseForm.patchValue({medfiId: this.medfiId, 
      logpwPolicydate:this.patWiseF.logpwPolicydate.value ? this.sharedService.getDateFormat(this.patWiseF.logpwPolicydate.value) : null,
      logpwPolicyExpirydate:this.patWiseF.logpwPolicyExpirydate.value ? this.sharedService.getDateFormat(this.patWiseF.logpwPolicyExpirydate.value) : null});
    this.medicalFileService.saveLogPatientWise(this.logisticsPatientWiseForm.value).subscribe(res => {
      if (res && res["result"]) {
        this.modal.dismissAll();
        this.getPatientWiseByKey();
        swal.fire("Success", res['message'] ? res['message'] : "Saved Successfully", 'success');
      }
    });
  }

  patientMedicalPackageAddModal(addPatientMedicalPackage) {
    this.modal.open(addPatientMedicalPackage, { size: 'lg', container: '.page-content' });
  }
  saveLogisticPackage(type) {
    this.logisticPackageForm.patchValue({ medfiId: this.medfiId, logppPatientPackageType: type });
    this.medicalFileService.saveLogisticPackage(this.logisticPackageForm.value).subscribe(res => {
      if (res && res["result"]) {
        this.modal.dismissAll();
        this.getPatientWiseByKey();
        swal.fire("Success", res['message'] ? res['message'] : "Saved Successfully", 'success');
      }
    });
  }

  patientMedicalAccompanionAddModal(addPatientMedicalAccompanion) {
    this.modal.open(addPatientMedicalAccompanion, { container: '.page-content' });
  }
  saveAccompanionPackage(type) {
    this.logisticsPatientAccompanionPackageForm.patchValue({ medfiId: this.medfiId, logpaPatientAccompanionPackageType: type });
    this.medicalFileService.saveAccompanionPackage(this.logisticsPatientAccompanionPackageForm.value).subscribe(res => {
      if (res && res["result"]) {
        this.modal.dismissAll();
        this.getPatientWiseByKey();
        swal.fire("Success", res['message'] ? res['message'] : "Saved Successfully", 'success');
      }
    });
  }

  patientLogisticPackageAddModal(addpatientLogisticPackage) {
    this.modal.open(addpatientLogisticPackage, { size: 'lg', container: '.page-content' });
  }
  PatientLogisticAccompanionAddModal(addPatientLogisticAccompanion) {
    this.modal.open(addPatientLogisticAccompanion, { container: '.page-content' });
  }


  patientLogisticAddModal(addPatientLogistic) {
    this.modal.open(addPatientLogistic, { size: 'lg', container: '.page-content' });
  }

  savepatientLogistic() {

    this.patLogF.medfiId.setValue(this.medfiId);
    this.medicalFileService.saveLogisticPatient(this.patientLogisticForm.value).subscribe(res => {
      if (res && res["result"]) {
        this.modal.dismissAll();
        this.getPatientWiseByKey();
        swal.fire("Success", res['message'] ? res['message'] : "Saved Successfully", 'success');
      }
    });
  }


  patientAccomodationAddModal(addPatientAccomodation) {
    this.modal.open(addPatientAccomodation, { size: 'lg', container: '.page-content' });
  }

  savePatientAccomadation() {
    this.patAccF.medfiId.setValue(this.medfiId);
    this.medicalFileService.savePatientAccomadation(this.patientAccomadationForm.value).subscribe(res => {
      if (res && res["result"]) {
        this.modal.dismissAll();
        this.getPatientWiseByKey();
        swal.fire("Success", res['message'] ? res['message'] : "Saved Successfully", 'success');
      }
    });
  }

  transportAddModal(addTransport) {
    this.modal.open(addTransport, { size: 'lg', container: '.page-content' });
  }

  saveLogisticFollowupTransport() {
    this.logisticFollowUpTransportForm.patchValue({medfiId: this.medfiId, 
      planneddate:this.followTranF.planneddate.value ? this.sharedService.getDateFormat(this.followTranF.planneddate.value) : null,
      aptdate:this.followTranF.aptdate.value ? this.sharedService.getDateFormat(this.followTranF.aptdate.value) : null});
    this.medicalFileService.saveLogisticFollowupTransport(this.logisticFollowUpTransportForm.value).subscribe(res => {
      if (res && res["result"]) {
        this.modal.dismissAll();
        this.getPatientWiseByKey();
        swal.fire("Success", res['message'] ? res['message'] : "Saved Successfully", 'success');
      }
    });
  }

  accomodationAddModal(addAccomodation) {
    this.modal.open(addAccomodation, { size: 'lg', container: '.page-content' });
  }

  saveLogisticFollowupAccomadation() {
    this.logisticFollowUpAccomadationForm.patchValue({medfiId: this.medfiId, 
      planneddate:this.followAccF.planneddate.value ? this.sharedService.getDateFormat(this.followAccF.planneddate.value) : null,
      arrival:this.followAccF.arrival.value ? this.sharedService.getDateFormat(this.followAccF.arrival.value) : null});
    this.medicalFileService.saveLogisticFollowupAccomadation(this.logisticFollowUpAccomadationForm.value).subscribe(res => {
      if (res && res["result"]) {
        this.modal.dismissAll();
        this.getPatientWiseByKey();
        swal.fire("Success", res['message'] ? res['message'] : "Saved Successfully", 'success');
      }
    });
  }

  otherLogisticsAddModal(addOtherLogistics) {
    this.modal.open(addOtherLogistics, { size: 'lg', container: '.page-content' });
  }

  saveLogisticFollowupOther() {
    this.logisticFollowupOtherForm.patchValue({medfiId: this.medfiId, 
      date:this.followOthrF.date.value ? this.sharedService.getDateFormat(this.followOthrF.date.value) : null});
    this.medicalFileService.saveLogisticFollowupOther(this.logisticFollowupOtherForm.value).subscribe(res => {
      if (res && res["result"]) {
        this.modal.dismissAll();
        this.getPatientWiseByKey();
        swal.fire("Success", res['message'] ? res['message'] : "Saved Successfully", 'success');
      }
    });
  }

  getPatientWiseByKey() {
    this.medicalFileService.getMedicalFilesByKey(this.medfiId, this.MD_FILE_PARAM_KEY).subscribe(response => {
      let masterValues = response['result'];
      this.patientWiseList = masterValues[CommonConstants.MED_LOGISTIC_PAT_WISE];
      let pkgList = masterValues[CommonConstants.MED_LOGISTIC_PAT_LOGISTIC_PACKAGE];
      this.medicalPackageList = pkgList.filter(item => item.logppPatientPackageType === this.medicalPkgType);
      this.medicalPackageList = this.medicalPackageList.map(item => ({
        ...item,
        catValue: item.lpcatId && item.lpcatId != "" ? this.msCategory.find(obj => obj.id === +item.lpcatId).value : null
      }));
      this.logisticPackageList = pkgList.filter(item => item.logppPatientPackageType === this.patientPkgType);
      this.logisticPackageList = this.logisticPackageList.map(item => ({
        ...item,
        catValue: item.lpcatId && item.lpcatId != "" ? this.msCategory.find(obj => obj.id === +item.lpcatId).value : null
      }));
      let accPkgList = masterValues[CommonConstants.MED_LOGISTIC_PAT_ACCOMDATION_PACKAGE];
      this.accompanionMedPackageList = accPkgList.filter(item => item.logpaPatientAccompanionPackageType === this.accompanionPkgTypeMed);
      this.accompanionMedPackageList = this.accompanionMedPackageList.map(item => ({
        ...item,
        logpaMedicalaccValue: item.logpaMedicalacc && item.logpaMedicalacc != "" ? this.msMedicalAccomadation.find(obj => obj.id === +item.logpaMedicalacc).value : null
      }));
      this.accompanionLogPackageList = accPkgList.filter(item => item.logpaPatientAccompanionPackageType === this.accompanionPkgTypeLog);
      this.accompanionLogPackageList = this.accompanionLogPackageList.map(item => ({
        ...item,
        logpaMedicalaccValue: item.logpaMedicalacc && item.logpaMedicalacc != "" ? this.msMedicalAccomadation.find(obj => obj.id === +item.logpaMedicalacc).value : null
      }));

      this.patientLogisticList = masterValues[CommonConstants.MED_LOGISTIC_PAT_LOGISTIC].map(item =>({
        ...item,
        logplConcernedtypeVal: item.logplConcernedtype && item.logplConcernedtype != "" ? this.msConcerned.find(obj => obj.id === +item.logplConcernedtype).value : null,
        relatIdVal: item.relatId && item.relatId != "" ? this.msRelationship.find(obj => obj.id === +item.relatId).value : null,
        fltypIdVal: item.fltypId && item.fltypId != "" ? this.msFlightType.find(obj => obj.id === +item.fltypId).value : null
      }));
      this.folowupTransportList = masterValues[CommonConstants.MED_LOGISTIC_FOLLOW_TRANSPORT];
      this.followupAccomadationList = masterValues[CommonConstants.MED_LOGISTIC_FOLLOW_ACCOMDATION].map(item =>({
        ...item,
        reasonVal: item.reason && item.reason != "" ? this.msFollowupReason.find(obj => obj.id === +item.reason).value : null
      }));
      this.followupOtherList = masterValues[CommonConstants.MED_LOGISTIC_FOLLOW_OTHER];
      this.patientAccomadationList = masterValues[CommonConstants.MED_LOGISTIC_PAT_ACCOMDATION].map(item =>({
        ...item,
        logplConcernedtypeVal: item.logplConcernedtype && item.logplConcernedtype != "" ? this.msConcerned.find(obj => obj.id === +item.logplConcernedtype).value : null,
        relatIdVal: item.relatId && item.relatId != "" ? this.msRelationship.find(obj => obj.id === +item.relatId).value : null,
        fltypIdVal: item.fltypId && item.fltypId != "" ? this.msFlightType.find(obj => obj.id === +item.fltypId).value : null,
        actypIdVal: item.actypId && item.actypId != "" ? this.msAccomadationType.find(obj => obj.id === +item.actypId).value : null
      }));
    })
  }


  onPatientWiseRowSelect(obj, modelId) {
    this.modal.open(modelId, { size: 'lg', container: '.page-content' });
    if (obj.data) {
      Object.keys(obj.data).forEach(name => {
        if (this.patWiseF[name]) {
          this.patWiseF[name].patchValue(obj.data[name]);
        }
      });
    }
  }

  onMedicalPackageRowSelect(obj, modelId) {
    this.modal.open(modelId, { size: 'lg', container: '.page-content' });
    if (obj.data) {
      Object.keys(obj.data).forEach(name => {
        if (this.medPackF[name]) {
          this.medPackF[name].patchValue(obj.data[name]);
        }
      });
    }
  }

  onAccompanionPackageRowSelect(obj, modelId) {
    this.modal.open(modelId, { size: 'lg', container: '.page-content' });
    if (obj.data) {
      Object.keys(obj.data).forEach(name => {
        if (this.medAccF[name]) {
          this.medAccF[name].patchValue(obj.data[name]);
        }
      });
    }
  }

  onFollowupTransportRowSelect(obj, modelId) {
    this.modal.open(modelId, { size: 'lg', container: '.page-content' });
    if (obj.data) {
      Object.keys(obj.data).forEach(name => {
        if (this.followTranF[name] && name === "reason" || name === "gender" || name === "specialneed" || name === "payment"
          || name === "status") {
          this.followTranF[name].patchValue(+obj.data[name]);
        } else {
          this.followTranF[name].patchValue(obj.data[name]);
        }
      });
    }
  }

  onFollowupAccomadationRowSelect(obj, modelId) {
    this.modal.open(modelId, { size: 'lg', container: '.page-content' });
    if (obj.data) {
      Object.keys(obj.data).forEach(name => {
        if (this.followTranF[name] && name === "reason" || name === "gender" || name === "roomtype" || name === "payment"
          || name === "accessibility") {
          this.followTranF[name].patchValue(+obj.data[name]);
        } else {
          this.followTranF[name].patchValue(obj.data[name]);
        }
      });
    }
  }

  onFollowupOtherRowSelect(obj, modelId) {
    this.modal.open(modelId, { size: 'lg', container: '.page-content' });
    if (obj.data) {
      Object.keys(obj.data).forEach(name => {
        if (this.followTranF[name] && name === "number") {
          this.followOthrF[name].patchValue(+obj.data[name]);
        } else {
          this.followOthrF[name].patchValue(obj.data[name]);
        }
      });
    }
  }

  onPatienLogisticRowSelect(obj, modelId) {
    this.modal.open(modelId, { size: 'lg', container: '.page-content' });
    if (obj.data) {
      Object.keys(obj.data).forEach(name => {
        if (this.patLogF[name] && name === "logplConcernedtype" || name === "relatId" || name === "fltypId") {
          this.patLogF[name].patchValue(+obj.data[name]);
        } else {
          this.patLogF[name].patchValue(obj.data[name]);
        }
      });
    }
  }

  onPatienAccomadationRowSelect(obj, modelId) {
    this.modal.open(modelId, { size: 'lg', container: '.page-content' });
    if (obj.data) {
      Object.keys(obj.data).forEach(name => {
        if (this.patAccF[name] && name === "logpaConcernedtype" || name === "relatId" || name === "actypId"
          || name === "rotypId") {
          this.patAccF[name].patchValue(+obj.data[name]);
        } else {
          this.patAccF[name].patchValue(obj.data[name]);
        }
      });
    }
  }

  reset(){
    this.logisticsPatientWiseForm.reset();
    this.logisticPackageForm.reset();
    this.logisticsPatientAccompanionPackageForm.reset();
    this.logisticFollowUpTransportForm.reset();
    this.logisticFollowUpAccomadationForm.reset();
    this.logisticFollowupOtherForm.reset();
    this.patientLogisticForm.reset();
    this.logisticPackageForm.reset();
    this.patientAccomadationForm.reset();
  }
}
